export default __webpack_public_path__ + "static/callumArticleThumbnail-839f4978cf8299d75681d464553f0b97.jpg";